var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center h-64"},[_c('div',{staticClass:"w-10 h-10 text-cerulean-500"},[_c('w-loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }